"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  COS_TEMPLATE_LAYOUT: null,
  INDUSTRY: null,
  COS_TEMPLATE_INTENT: null,
  COS_TEMPLATE_FEATURES: null,
  COS_TEMPLATE_CODING_TYPE: null,
  MODULE_COMPATIBILITY: null,
  MODULE_PURPOSE: null
});

exports.default = _default;
module.exports = exports.default;